import Layout from '@/layouts/Layout'

// 采购

const purchase = {
  path: '/purchase_new',
  component: Layout,
  name: 'purchase_new',
  meta: {
    title: '采购',
    icon: 'user-menu',
  },
  children: [
    {
      path: '/purchaseNew/purchaseOrder/list',
      name: 'purchase_new_order',
      component: () =>
        import('@/pages/carsService/purchaseOrder/list/index.vue'),
      meta: { title: '采购订单' },
    },
    {
      path: '/purchaseNew/serviceProvider/list',
      name: 'purchase_new_provider',
      component: () => import('@/pages/customers/servicesManage/serviceProvider/list'),
      meta: { title: '服务商列表', logEvent: '' },
    },
    {
      path: '/purchaseNew/maintenanceReview/list',
      name: 'maintenance_review',
      component: () => import('@/pages/customers/servicesManage/maintenanceReview/list/index.vue'),
      meta: { title: '维保入住审核', logEvent: '' },
    },
    {
      path: '/purchaseNew/maintenanceReview/list_detail',
      name: 'maintenance_review_detail',
      component: () => import('@/pages/customers/servicesManage/maintenanceReview/detail/index.vue'),
      meta: { title: '维保入住审核详情' },
      hidden: true,
    },
    {
      path: '/purchaseNew/purchaseOrder/detail',
      name: 'purchase_new_order_list_detail',
      component: () =>
        import('@/pages/carsService/purchaseOrder/detail/index.vue'),
      meta: { title: '采购订单详情' },
      hidden: true,
    },
    {
      path: '/purchaseNew/purchaseOrder/add',
      name: 'purchase_new_order_list_create',
      component: () =>
        import('@/pages/carsService/purchaseOrder/add/index.vue'),
      meta: {
        title: '新建采购订单',
        parent: {
          path: '/purchaseNew/purchaseOrder/list',
          name: 'purchase_new_order',
          title: '采购订单',
        },
      },
      hidden: true,
    },
    {
      path: '/purchaseNew/purchaseOrder/add/addCar',
      name: 'purchase_new_order_list_additional',
      component: () =>
        import('@/pages/carsService/purchaseOrder/add/addCar.vue'),
      meta: {
        title: '新增采购车辆',
        parent: {
          path: '/purchaseNew/purchaseOrder/list',
          name: 'purchase_new_order',
          title: '采购订单',
        },
      },
      hidden: true,
    },
    {
      path: '/purchaseNew/purchaseOrder/list/orderClose',
      name: 'purchase_new_order_list_close',
      component: () =>
        import('@/pages/carsService/purchaseOrder/list/pages/orderClose/index.vue'),
      meta: { title: '采购订单关闭',
        parent: {
          path: '/purchaseNew/purchaseOrder/list',
          name: 'purchase_new_order',
          title: '采购订单',
        } },
      hidden: true,
    },
    {
      path: '/purchaseNew/purchaseOrder/list/batchExitCar',
      name: 'purchase_new_order_list_batch_return_car',
      component: () =>
        import('@/pages/carsService/purchaseOrder/list/pages/batchExitCar/index.vue'),
      meta: { title: '采购批量退车',
        parent: {
          path: '/purchaseNew/purchaseOrder/list',
          name: 'purchase_new_order',
          title: '采购订单',
        } },
      hidden: true,
    },
    {
      path: '/purchaseOrder/sonOrderMange/detail',
      name: 'purchase_new_order_list_sub_detail',
      // component: () => import('@/pages/orders/personalOrder/detail'),
      component: () =>
        import('@/pages/carsService/purchaseOrder/detail/sonOrder.vue'),
      meta: { title: '采购子订单详情' },
      hidden: true,
    },
    {
      path: '/purchaseOrder/sonOrderMange/paymentDetail',
      name: 'purchase_new_order_list_sub_detail',
      meta: { title: '订单收款详情' },
      component: () => import('@/pages/orders/paymentDetail'),
      hidden: true,
    },
    // 采购-信息管理
    {
      path: '/purchaseProvide/infoManage',
      name: 'purchase_info_manage',
      component: () => import('@/pages/carResource/infoManage/index.vue'),
      meta: { title: '信息管理-列表页', logEvent: '' },
    },
    {
      path: '/purchaseProvide/infoManage/publish',
      name: 'purchase_info_manage_publish',
      component: () => import('@/pages/carResource/infoManage/publish.vue'),
      meta: { title: '信息管理-发布页',
        logEvent: '',
        keepAlive: false,
        parent: [
          {
            path: '/purchaseProvide/infoManage',
            name: 'purchase_info_manage',
            title: '信息管理-列表页',
          },
        ] },
      hidden: true,
    },
    {
      path: '/purchaseProvide/infoManage/detail',
      name: 'purchase_info_manage_detail',
      component: () => import('@/pages/carResource/infoManage/detail.vue'),
      meta: { title: '信息管理-详情页', logEvent: '', keepAlive: false },
      hidden: true,
    },
    // 采购-商机管理
    {
      path: '/purchaseProvide/businessManage',
      name: 'purchase_business_manage',
      component: () => import('@/pages/carResource/businessManage/index.vue'),
      meta: { title: '商机管理-列表页', logEvent: '' },
    },
    {
      path: '/purchaseProvide/businessManage/detail',
      name: 'purchase_business_manage_detail',
      component: () => import('@/pages/carResource/businessManage/detail.vue'),
      meta: { title: '商机管理-详情页', logEvent: '', keepAlive: false },
      hidden: true,
    },
    {
      path: '/purchaseOrder/resourceCenter/list',
      name: 'car_resource_center',
      component: () => import('@/pages/carResource/resourceCenter/list.vue'),
      meta: { title: '车源信息列表', logEvent: '' },
    },
    {
      path: '/purchaseOrder/resourceCenter/detail',
      name: 'car_resource_center_detail',
      component: () => import('@/pages/carResource/resourceCenter/detail.vue'),
      meta: { title: '车源信息详情', logEvent: '', keepAlive: false },
      hidden: true,
    },
    {
      path: '/purchaseOrder/resourceCenter/calculate',
      name: 'car_resource_center_earnings_calculation',
      component: () =>
        import('@/pages/carResource/resourceCenter/calculate.vue'),
      meta: { title: '盈收测算', logEvent: '', keepAlive: false },
      hidden: true,
    },
    {
      path: '/purchaseProvide/maintenanceOrderList',
      name: 'maintenanceOrderList',
      component: () => import('@/pages/purchaseProvide/maintenanceOrderList'),
      meta: { title: '订单列表', logEvent: '' },
    },
    {
      path: '/purchaseProvide/maintenanceRefundList',
      name: 'maintenanceRefundList',
      component: () => import('@/pages/purchaseProvide/maintenanceRefundList'),
      meta: { title: '退款列表', logEvent: '' },
    },
    {
      path: '/purchaseProvide/maintenanceOrderDetail',
      name: 'maintenanceOrderDetail',
      component: () => import('@/pages/purchaseProvide/maintenanceOrderDetail'),
      meta: { title: '订单详情', logEvent: '' },
      hidden: true,
    },
    {
      path: '/purchaseProvide/maintenanceMall',
      name: 'maintenanceMall',
      meta: { title: '维保商城', logEvent: '' },
    },
  ],
}

export default purchase
